export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_service_attachment": {
            "service_template_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo de archivo"])},
            "container_service_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjunto"])}
          }
        }
      },
      "en": {
        "model": {
          "container_service_attachment": {
            "service_template_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["File type"])},
            "container_service_attach": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attach"])}
          }
        }
      }
    }
  })
}